import { enableProdMode, APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { NgIdleModule } from '@ng-idle/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { NgRenaultFeedbackModule } from 'ng-renault-feedback';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppRoutingModule } from './app/app-routing.module';
import { MatInputModule } from '@angular/material/input';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { MATOMO_CONFIGURATION, MatomoModule } from 'ngx-matomo';
import { CustomDateAdapter } from './app/_helpers/date-adapter';
import { NgbDateCustomParserFormatter } from './app/_helpers/date-picker-format';
import { NgbDateParserFormatter, NgbDateAdapter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PagerService } from './app/_service/pager-service';
import { HttpConfigInterceptor } from './app/interceptor/httpconfig.interceptor.ts';
import { HttpErrorInterceptor } from './app/interceptor/httperrorinterceptor.service';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Helper } from './app/_helpers/helper';
import { CommonService } from './app/_service/common.service';
import { appInitializer } from './app/_helpers/app-initializer';
import { ImportbvdService } from './app/_service/importbvd.service';
import { BlankstatusService } from './app/_service/blankstatus.service';
import { ConfigService } from './app/_service/config.service';

if (environment.production) {
  console.info('is env',environment);
  enableProdMode();
}

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));

 window.onload = function () { bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, MatAutocompleteModule, NgxPaginationModule, MatInputModule, AppRoutingModule, MatomoModule, MatProgressSpinnerModule, NgSelectModule, FormsModule, ReactiveFormsModule, MatSnackBarModule, NgRenaultFeedbackModule, NgbModule, MatIconModule, MatSelectModule, NgxMatSelectSearchModule, MatTooltipModule, MatProgressBarModule, NgIdleModule.forRoot()),
        ConfigService,
        BlankstatusService,
        ImportbvdService,
        {
            provide: APP_INITIALIZER, useFactory: appInitializer, deps: [ConfigService], multi: true
        },
        CommonService, Helper, DatePipe,
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true }, PagerService,
        { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
        { provide: NgbDateAdapter, useClass: CustomDateAdapter },
        {
            provide: MATOMO_CONFIGURATION,
            useValue: {
                trackerUrl: environment.matomoUrl + 'matomo.php',
                siteId: environment.matomoId
            }
        },
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi())
    ]
}); }
